import styled from 'styled-components';

export const LoadingContainer = styled.div`
  position: fixed;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 901;
  display: flex;
  align-items: center;
  justify-content: center;
`;

/* Solid, theme-aware canvas background (not a translucent white) so the backdrop reads
   correctly in both light and dark mode instead of washing out as a flat gray over a dark page. */
export const LoadingDisabler = styled.div`
  background: var(--color-surface-canvas);
  height: 100%;
  position: fixed;
  width: 100%;
  z-index: 900;
`;
